import { useEffect, useRef } from 'react'
import { ShopCheckoutSideBarResponse } from 'src/Libs/shop/models'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import useModals from 'src/Hooks/useModals'
import { ProductGeneralType, ShopSystemConfigurationTypes } from '../types'

/*
 * This custom hook handles the logic when product quantity type changes and triggers a note modal on change
 * Doesnt show up initialy
 */
export const useQuantityTypeChangeModal = (products: ShopCheckoutSideBarResponse | null): void => {
  const prevTypes = useRef<Record<string, string>>({})
  const { openShopHintModal } = useModals()
  const { t } = useCustomTranslation()

  useEffect(() => {
    if (!products?.lineItems?.length) return

    for (const item of products.lineItems) {
      if (item.type !== ProductGeneralType.SYSTEM_CONFIGURATOR) continue

      const changedToFlex =
        prevTypes.current[item.id] === ShopSystemConfigurationTypes.Fix && item.payload.quantityType === ShopSystemConfigurationTypes.Flex

      const changedToFix =
        prevTypes.current[item.id] === ShopSystemConfigurationTypes.Flex && item.payload.quantityType === ShopSystemConfigurationTypes.Fix

      if (changedToFlex) {
        openShopHintModal({ text: t('shop.confirm-checkout.note-configurator-type-flex') })
      }

      if (changedToFix) {
        openShopHintModal({ text: t('shop.confirm-checkout.note-configurator-type-fix') })
      }

      prevTypes.current[item.id] = item.payload.quantityType
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products])
}
